(() => {
  'use strict';

  const ROOT_FLAG = 'data-vd-policy-pdp-links-hotfix';
  if (document.documentElement.hasAttribute(ROOT_FLAG)) return;
  document.documentElement.setAttribute(ROOT_FLAG, '1');

  const normalizeText = (value) => (value || '').replace(/\s+/g, ' ').trim();
  const cleanSummary = (value) => normalizeText(value).replace(/\s*Voir les détails\s*$/i, '').trim();
  const escapeHtml = (value) => String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

  const hrefWithPreview = (path) => {
    try {
      const destination = new URL(path, window.location.origin);
      const current = new URL(window.location.href);
      const previewThemeId = current.searchParams.get('preview_theme_id');
      if (previewThemeId && destination.origin === window.location.origin) {
        destination.searchParams.set('preview_theme_id', previewThemeId);
      }
      return `${destination.pathname}${destination.search}${destination.hash}`;
    } catch (error) {
      return path;
    }
  };

  const scrollToLegalDocument = (root) => {
    const target = root && root.querySelector('#vdlegal-document');
    if (!target) return;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
    try {
      history.replaceState(null, '', '#vdlegal-document');
    } catch (error) {}
  };

  const fixPolicyNavigation = () => {
    const root = document.querySelector('[data-vdlegal]');
    if (!root) return;

    root.querySelectorAll('.vdlegal-index__row.is-current').forEach((link) => {
      link.setAttribute('href', '#vdlegal-document');
      link.setAttribute('data-vdlegal-current-document', 'true');
      const arrow = link.querySelector('.vdlegal-index__arrow');
      if (arrow) arrow.textContent = '↓';
    });

    root.querySelectorAll('a[href="#vdlegal-document"]').forEach((link) => {
      if (link.dataset.vdlegalScrollBound === 'true') return;
      link.dataset.vdlegalScrollBound = 'true';
      link.addEventListener('click', (event) => {
        event.preventDefault();
        scrollToLegalDocument(root);
      });
    });

    if (window.location.hash === '#vdlegal-document' && root.dataset.vdlegalHashHandled !== 'true') {
      root.dataset.vdlegalHashHandled = 'true';
      requestAnimationFrame(() => scrollToLegalDocument(root));
    }
  };

  const findProductInfoBlock = (matcher) => {
    const blocks = [...document.querySelectorAll('.product-info__block-item')];
    return blocks.find((block) => matcher(cleanSummary(block.textContent)));
  };

  const addPolicyLink = (block, href, label, marker) => {
    if (!block || block.querySelector(`[data-vd-policy-link="${marker}"]`)) return;

    const wrapper = document.createElement('div');
    wrapper.setAttribute('data-vd-policy-link', marker);
    wrapper.style.marginTop = '6px';

    const link = document.createElement('a');
    link.href = hrefWithPreview(href);
    link.textContent = label;
    link.className = 'link-faded text-sm';
    link.style.textDecoration = 'underline';
    link.style.textUnderlineOffset = '3px';

    wrapper.appendChild(link);
    block.appendChild(wrapper);
  };

  const buildShippingReturnsHtml = (deliveryText, returnText) => {
    const delivery = deliveryText || 'Les délais et modalités de livraison varient selon le produit, sa disponibilité, son volume et le transporteur.';
    const returns = returnText || 'Le droit de rétractation et les modalités de retour dépendent des conditions applicables à la commande.';
    const shippingHref = hrefWithPreview('/policies/shipping-policy#vdlegal-document');
    const refundHref = hrefWithPreview('/policies/refund-policy#vdlegal-document');

    return `
      <h4>Livraison</h4>
      <p>${escapeHtml(delivery)}</p>
      <p><a href="${escapeHtml(shippingHref)}">Consulter la politique de livraison</a></p>
      <h4>Retours &amp; remboursements</h4>
      <p>${escapeHtml(returns)}</p>
      <p><a href="${escapeHtml(refundHref)}">Consulter la politique de retours et remboursements</a></p>
    `;
  };

  const fixProductShippingReturns = () => {
    if (!document.body.classList.contains('template-product') && !document.querySelector('product-rerender')) return;

    const deliveryBlock = findProductInfoBlock((text) => /^Délai de livraison\s*:/i.test(text));
    const returnBlock = findProductInfoBlock((text) => /^Retours?\b/i.test(text));
    const deliveryText = deliveryBlock ? cleanSummary(deliveryBlock.textContent) : '';
    const returnText = returnBlock ? cleanSummary(returnBlock.textContent) : '';

    addPolicyLink(
      deliveryBlock,
      '/policies/shipping-policy#vdlegal-document',
      'Voir les conditions de livraison',
      'shipping'
    );
    addPolicyLink(
      returnBlock,
      '/policies/refund-policy#vdlegal-document',
      'Voir les conditions de retour',
      'returns'
    );

    const trigger = [...document.querySelectorAll('button[aria-controls], a[aria-controls]')].find((element) =>
      /expéditions?\s+et\s+retours?/i.test(normalizeText(element.textContent))
    );
    if (!trigger) return;

    const modalId = trigger.getAttribute('aria-controls');
    const modal = modalId ? document.getElementById(modalId) : null;
    const content = modal ? modal.querySelector('.prose') : null;
    if (!content || content.dataset.vdShippingReturnsFilled === 'true') return;

    const existingText = normalizeText(content.textContent);
    if (existingText.length < 20) {
      content.innerHTML = buildShippingReturnsHtml(deliveryText, returnText);
    } else {
      if (!content.querySelector('a[href*="shipping-policy"]')) {
        const shippingParagraph = document.createElement('p');
        const shippingLink = document.createElement('a');
        shippingLink.href = hrefWithPreview('/policies/shipping-policy#vdlegal-document');
        shippingLink.textContent = 'Consulter la politique de livraison';
        shippingParagraph.appendChild(shippingLink);
        content.appendChild(shippingParagraph);
      }
      if (!content.querySelector('a[href*="refund-policy"]')) {
        const refundParagraph = document.createElement('p');
        const refundLink = document.createElement('a');
        refundLink.href = hrefWithPreview('/policies/refund-policy#vdlegal-document');
        refundLink.textContent = 'Consulter la politique de retours et remboursements';
        refundParagraph.appendChild(refundLink);
        content.appendChild(refundParagraph);
      }
    }

    content.dataset.vdShippingReturnsFilled = 'true';
  };

  const addFaqPolicyLink = (selector, href, label, marker) => {
    const header = document.querySelector(selector);
    if (!header || header.querySelector(`[data-vd-faq-policy-link="${marker}"]`)) return;

    const link = document.createElement('a');
    link.href = hrefWithPreview(href);
    link.textContent = label;
    link.className = 'vdfaq-rule-link';
    link.setAttribute('data-vd-faq-policy-link', marker);
    link.style.marginTop = '18px';
    header.appendChild(link);
  };

  const fixFaqPolicyLinks = () => {
    if (!document.querySelector('[data-vdfaq-page]')) return;
    addFaqPolicyLink(
      '#vdfaq-2 .vdfaq-chapter__head',
      '/policies/shipping-policy#vdlegal-document',
      'Consulter la politique de livraison ↗',
      'shipping'
    );
    addFaqPolicyLink(
      '#vdfaq-5 .vdfaq-chapter__head',
      '/policies/refund-policy#vdlegal-document',
      'Consulter la politique de retours et remboursements ↗',
      'returns'
    );
  };

  let scheduled = false;
  const applyFixes = () => {
    scheduled = false;
    fixPolicyNavigation();
    fixProductShippingReturns();
    fixFaqPolicyLinks();
  };
  const scheduleFixes = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(applyFixes);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleFixes, { once: true });
  } else {
    scheduleFixes();
  }

  document.addEventListener('shopify:section:load', scheduleFixes);

  const startObserver = () => {
    if (!document.body) return;
    const observer = new MutationObserver(scheduleFixes);
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.body) startObserver();
  else document.addEventListener('DOMContentLoaded', startObserver, { once: true });
})();
